import { render, staticRenderFns } from "./DeleteExamModal.vue?vue&type=template&id=3b548e73&scoped=true&"
import script from "./DeleteExamModal.vue?vue&type=script&lang=js&"
export * from "./DeleteExamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b548e73",
  null
  
)

export default component.exports